module.exports = __webpack_public_path__ + "media/images/marketapp-logo-b648c48c.jpg";